
import { defineComponent } from "vue";

const isMobile = () => {
  const userAgent = navigator.userAgent;
  const agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPod",
    "iPad",
  ];
  for (let i = 0; i < agents.length; i++) {
    if (userAgent.indexOf(agents[i]) >= 0) return true;
  }
  return false;
};

export default defineComponent({
  setup: () => {
    const { origin } = window.location;
    if (isMobile()) {
      window.location.href = `${origin}/sign/show.html`;
    }
  },
});
